import classnames from "classnames";
import Button from "components/Button/Button";
import Collapsible from "components/Collapsible/Collapsible";
import { makeGetIsNextBlockRevealed } from "funkis-template/../selectors/playerSelectors";
import { revealNext } from "funkis-template/actions/Actions";
import Text from "funkis-template/components/core/Text";
import { PageItem, TextId } from "funkis-template/models/player";
import { forwardRef, useState } from "react";
import { useSelector } from "react-redux";
import Style from "./RevealNextButton.module.css";

const selectIsNextPageRevealed = makeGetIsNextBlockRevealed();

type RevealNextButtonProps = {
	pageItem: PageItem<any>;
	textId: TextId;
	show: boolean;
	onClick: () => void;
	isNextBlockRevealed?: boolean;
};

const RevealNextButton = forwardRef<HTMLDivElement, RevealNextButtonProps>(
	(props, ref) => {
		const {
			pageItem,
			textId,
			show: shouldShowAccordingToParent = true,
			onClick,
		} = props;

		const isNextBlockRevealed = useSelector((state) =>
			selectIsNextPageRevealed(state, props)
		);

		// NOTE: This should not be needed but something is buggy with the connected prop "isNextBlockRevealed"
		const [nextBlockRevealed, setNextBlockRevealed] =
			useState(isNextBlockRevealed);

		const isShowing = shouldShowAccordingToParent && !nextBlockRevealed;

		return (
			<div
				ref={ref}
				className={classnames(
					"reveal-next-button no-print row w-100 m-0 justify-content-center"
				)}
				aria-hidden={!isShowing}
			>
				<Collapsible open={isShowing} variant="fade-out-collapse">
					<div className={classnames(Style.revealContainer, "p-4")}>
						<Button
							disabled={!isShowing}
							onClick={() => {
								revealNext({ pageItem });
								onClick && onClick();
								setNextBlockRevealed(true);
							}}
						>
							<Text textId={textId} />
						</Button>
					</div>
				</Collapsible>
			</div>
		);
	}
);

export default RevealNextButton;
